var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-content warehouse-amazon-tab-content" },
    [
      _c(
        "div",
        {
          staticClass: "tab-pane",
          class: _vm.activeTab("top"),
          attrs: { id: "top" }
        },
        [_c("top", { attrs: { currentTab: _vm.tab } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tab-pane",
          class: _vm.activeTab("amazon-info"),
          attrs: { id: "amazon-info" }
        },
        [_c("amazon-info", { attrs: { currentTab: _vm.tab } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tab-pane",
          class: _vm.activeTab("multi-channel-service"),
          attrs: { id: "multi-channel-service" }
        },
        [_c("multi-channel-service", { attrs: { currentTab: _vm.tab } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tab-pane",
          class: _vm.activeTab("receive-amount-setting"),
          attrs: { id: "receive-amount-setting" }
        },
        [_c("receive-amount-setting", { attrs: { currentTab: _vm.tab } })],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-289584e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-289584e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAmazon/TabContent.vue
// module id = null
// module chunks = 